import { apiHolder, apis } from 'api';
import { isMainAccount, getTreeStatesByAccount } from '../../../util';
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { idIsTreadMail, getIsSearchingMailByState } from '../../customize';
import { MailListThunks, MailListExtraReducersList } from './listThunk';
import { FolderThunks, FolderExtraReducersList } from './folderThunks';
import { mailManageThunks, mailManageReducersList } from './mailManageThunks';
import { mailStateManageThunks, mailStateManageReducersList } from './mailStateManage';
import { searchThunk, searchReducersList } from './searchThunk';
import { MailListThunks_cm, MailListExtraReducersList_cm } from '@web-mail/state/slice/customerMailReducer/thunks/listThunk_cm';
import { FolderThunks_cm, FolderExtraReducersList_cm } from '@web-mail/state/slice/customerMailReducer/thunks/folderThunks_cm';
import { MailBoxThunks_cm, MailBoxExtraReducersList_cm } from '@web-mail/state/slice/customerMailReducer/thunks/mailBoxThunks_cm';
import { FolderThunks_sd, FolderExtraReducersList_sd } from '@web-mail/state/slice/subordinateMailReducer/thunks/folderThunks_sd';
import { MailBoxThunks_sd, MailBoxExtraReducersList_sd } from '@web-mail/state/slice/subordinateMailReducer/thunks/mailBoxThunks_sd';
import { SearchThunks_sd, SearchExtraReducersList_sd } from '@web-mail/state/slice/subordinateMailReducer/thunks/searchThunk_sd';
import { getIn18Text } from 'api';
import { tabId } from '@web-common/state/reducer/mailTabReducer';
const mailApis = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const ReducerName = 'MailReducer';
const Thunks = {};
const MailBoxExtraReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, MailBoxExtraReducersList);
thunkHelper({
    name: 'requestTaglist',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const { account } = params;
        if (account) {
            dispatch(Thunks.requestTaglistByAccount({ account }));
        }
        else {
            const state = thunkAPI.getState().mailReducer;
            const mailTreeStateMap = (state === null || state === void 0 ? void 0 : state.mailTreeStateMap) || {};
            for (let i in mailTreeStateMap) {
                if ((mailTreeStateMap[i] && !mailTreeStateMap[i].expired) || i == 'main') {
                    dispatch(Thunks.requestTaglistByAccount({ account: i == 'main' ? '' : i }));
                }
            }
        }
    },
    fulfilled: (state, action) => { },
});
thunkHelper({
    name: 'getDeliveryTagUnread',
    request: async (params) => {
        const { value, account } = params;
        return mailApis.getDeliveryTagUnread(value, account);
    },
    fulfilled: (state, action) => {
        var _a;
        const res = action.payload;
        const { value, account } = ((_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.arg) || {};
        if (res != null) {
            if (isMainAccount(account)) {
                state.mailTreeStateMap.main.wmDeliveryTagUnRead = Object.assign(Object.assign({}, state.mailTreeStateMap.main.wmDeliveryTagUnRead), { [value == 3 ? '__deliveryrecord__' : '__delivery__']: res });
            }
            else {
                const map = getTreeStatesByAccount(state.mailTreeStateMap, account);
                if (map) {
                    map.wmDeliveryTagUnRead = Object.assign(Object.assign({}, map.wmDeliveryTagUnRead), { [value == 3 ? '__deliveryrecord__' : '__delivery__']: res });
                }
            }
        }
    },
});
thunkHelper({
    name: 'requestTaglistByAccount',
    request: async (params, thunkAPI) => {
        const { account } = params;
        const { dispatch, rejectWithValue } = thunkAPI;
        if (process.env.BUILD_ISEDM) {
            dispatch(Thunks.getDeliveryTagUnread({ value: 3, account }));
            dispatch(Thunks.getDeliveryTagUnread({ value: 4, account }));
        }
        return mailManagerApi.requestTaglist(account);
    },
    fulfilled: (state, action) => {
        var _a, _b;
        const res = action.payload;
        const account = (_b = (_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.arg) === null || _b === void 0 ? void 0 : _b.account;
        if (res) {
            if (res.length > 300) {
                if (isMainAccount(account)) {
                    state.mailTreeStateMap.main.mailTagList = res.slice(0, 300);
                }
                else {
                    const map = getTreeStatesByAccount(state.mailTreeStateMap, account);
                    if (map) {
                        map.mailTagList = res.slice(0, 300);
                    }
                }
            }
            else {
                if (isMainAccount(account)) {
                    state.mailTreeStateMap.main.mailTagList = res || [];
                }
                else {
                    const map = getTreeStatesByAccount(state.mailTreeStateMap, account);
                    if (map) {
                        map.mailTagList = res || [];
                    }
                }
            }
        }
    },
});
thunkHelper({
    name: 'refreshPage',
    request: async (_params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const { selectedKeys, mailDataList, mailTreeStateMap } = state;
        const isCorpMail = thunkAPI.getState().loginReducer.loginInfo.isCorpMailMode;
        if (!isCorpMail) {
            dispatch(Thunks.requestTaglist({}));
        }
        try {
            const isSearching = getIsSearchingMailByState(state);
            if ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.authAccountType) != null && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.authAccountType) != '0' && !isSearching && (mailDataList === null || mailDataList === void 0 ? void 0 : mailDataList.length) != 0) {
                const folderId = parseInt((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) + '');
                if (!isNaN(folderId)) {
                    mailApis.triggerReceive({
                        folderId: folderId,
                        _account: (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) || '',
                    });
                }
            }
        }
        catch (err) {
            console.log('[Error refreshPage-triggerReceive]', e);
        }
        try {
            const accountList = [];
            if (mailTreeStateMap) {
                for (let i in mailTreeStateMap) {
                    if (i != 'main') {
                        accountList.push(i);
                    }
                }
            }
            await Promise.all([
                dispatch(FolderThunks.refreshFolder({ noCache: true })),
                dispatch(MailListThunks.refreshMailList({ showLoading: false, noCache: true })),
                dispatch(FolderThunks.getUserFolderAlias({ accountList })),
                process.env.BUILD_ISLINGXI && dispatch(MailBoxThunks_sd.refreshPage_sd({ sliceId: tabId.subordinate })),
            ]);
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    pending: (state) => {
        state.refreshBtnLoading = true;
    },
    fulfilled: (state, action) => {
        var _a, _b;
        const { refreshHasNewMail } = state;
        const successCb = (_b = (_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.arg) === null || _b === void 0 ? void 0 : _b.successCb;
        if (successCb) {
            successCb(refreshHasNewMail);
        }
        state.refreshHasNewMail = false;
        state.refreshBtnLoading = false;
        state.noticeNum = 0;
        state.refreshLoading = false;
    },
    rejected: (state, action) => {
        const showMessage = action.meta.arg || true;
        if (showMessage) {
            reduxMessage.success({
                content: getIn18Text('SHOUXINSHIBAI'),
            });
        }
        state.refreshBtnLoading = false;
        state.refreshLoading = false;
    },
});
thunkHelper({
    name: 'openMailInNewWindow',
    request: async (params, thunkAPI) => {
        const id = params;
        const state = thunkAPI.getState().mailReducer;
        const { _account, isTpMail } = state.mailEntities[id] || {};
        if (id) {
            const isThread = idIsTreadMail(id);
            if (systemApi.isElectron()) {
                systemApi.createWindowWithInitData({ type: 'readMail', additionalParams: { account: _account } }, { eventName: 'initPage', eventData: { id: id, accountId: _account, isTpMail }, eventStrData: isThread ? 'isthread' : '' });
            }
            else {
                window.open(`${systemApi.getContextPath()}/readMail/?id=${id}${_account ? '&account=' + _account : ''}${isThread ? '&isthread=1' : ''}${isTpMail ? '&isTpMail=1' : ''}`, 'readMail', 'menubar=0,scrollbars=1,resizable=1,width=800,height=600');
            }
        }
    },
});
export const MailBoxThunks = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Thunks), MailListThunks), FolderThunks), mailManageThunks), mailStateManageThunks), searchThunk), MailListThunks_cm), FolderThunks_cm), MailBoxThunks_cm), FolderThunks_sd), MailBoxThunks_sd), SearchThunks_sd);
export const MailBoxExtraReducers = (builder) => {
    MailBoxExtraReducersList.forEach((fn) => fn(builder));
    MailListExtraReducersList.forEach((fn) => fn(builder));
    FolderExtraReducersList.forEach((fn) => fn(builder));
    mailManageReducersList.forEach((fn) => fn(builder));
    mailStateManageReducersList.forEach((fn) => fn(builder));
    searchReducersList.forEach((fn) => fn(builder));
    MailListExtraReducersList_cm.forEach((fn) => fn(builder));
    FolderExtraReducersList_cm.forEach((fn) => fn(builder));
    MailBoxExtraReducersList_cm.forEach((fn) => fn(builder));
    FolderExtraReducersList_sd.forEach((fn) => fn(builder));
    MailBoxExtraReducersList_sd.forEach((fn) => fn(builder));
    SearchExtraReducersList_sd.forEach((fn) => fn(builder));
};
